import React from "react";
import classes from "./WhyKc.module.scss";
import CustomImage from "../../CustomImage";
import ThreeCircles from "../../UI/Icons/ThreeCircles";
import useIsMobile from "../../../hooks/useIsMobile";

interface WhyKcHighlightImg {
  url: string;
  name: string;
}
interface WhyKcCard {
  id: number;
  title: string;
  description: string;
  highlightImg?: WhyKcHighlightImg;
  iconBgColor?: string;
}

interface WhyKcData {
  id: number;
  title: string;
  mobileTitle: string;
  card: WhyKcCard[];
}

interface Props {
  whyKcData?: WhyKcData;
}

const WhyKc = ({ whyKcData }: Props) => {
  const isMobile = useIsMobile(1024);

  return (
    <section className={classes["why-kc-container"]}>
      {!isMobile && (
        <div className={classes["circle-container"]}>
          <ThreeCircles />
        </div>
      )}

      {whyKcData?.title && <h2 className={classes.heading} dangerouslySetInnerHTML={{ __html: isMobile ? whyKcData?.mobileTitle : whyKcData?.title }} />}

      <div className={classes["card-grid"]}>
        {whyKcData?.card &&
          whyKcData?.card?.length > 0 &&
          whyKcData.card.map((card) => {
            return (
              <div key={card.id} className={classes.card}>
                {card?.highlightImg && (
                  <div className={classes.badge} style={{ background: card?.iconBgColor ?? "" }}>
                    <CustomImage src={card?.highlightImg?.url ?? ""} alt={card?.highlightImg?.name ?? "highlight.webp"} height={24} width={24} />
                  </div>
                )}
                {card.title && <h3 className={classes["card-title"]}>{card.title}</h3>}
                {card.description && <p className={classes["card-description"]}>{card.description}</p>}
              </div>
            );
          })}

        {!isMobile && <div className={classes["gradient-layer"]}></div>}
      </div>
    </section>
  );
};

export default WhyKc;
